<template>
  <div v-if="visible" :class="[isSmall?'batch-upload-dialog-small':'batch-upload-dialog']"
       ref="refBatchUploadDialogDiv">
    <div class="batch-upload-dialog-main"
         v-show="!isSmall"
         v-loading="showLoading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         :style="[{width:titleWidth}]">
      <div class="batch-upload-dialog-title">
        <span>{{ title }}</span>
        <i class="el-dialog__close el-icon el-icon-close"
           style="width: 18px; height: 18px; cursor: pointer;"
           @click.stop="hideDialog"></i>
      </div>
      <div class="batch-upload-dialog-content">
        <div class="batch-upload-step-first" v-if="matchStep==1"
             @dragover.stop.prevent="handlerDragover"
             @dragleave.stop.prevent="matchStep=1">
          <div class="step-first-top">
            <span>签字类型<span style="color: #ed6104;">*</span></span>
            <el-select size="mini" v-model="fileIsSeal" style="width: 430px;">
              <el-option label="未签章" value="2"></el-option>
              <el-option label="已签章" value="1"></el-option>
            </el-select>
          </div>
          <div class="step-first-content">
            <img src="@/assets/image/batch-upload-dialog/ic_scwj.png">
            <span>将上传文件夹拖动到此处</span>
            <button class="btn-load-temp" @click="downLoadTemp">下载范本</button>
          </div>
        </div>
        <div class="batch-upload-step-second" v-if="matchStep==2"
             webkitdirectory
             @drop.stop.prevent="handlerDrop"
             @dragover.stop.prevent="handlerDragover"
             @dragleave.stop.prevent="matchStep=1">
          <div class="step-first-top" @dragover.stop.prevent="()=>{}">
            <span>签字类型<span style="color: #ed6104;">*</span></span>
            <el-select size="mini" v-model="fileIsSeal" style="width: 430px;">
              <el-option label="未签章" value="2"></el-option>
              <el-option label="已签章" value="1"></el-option>
            </el-select>
          </div>
          <div class="step-second-content" @dragover.stop.prevent="()=>{}">
            <label>将文件夹拖到此处</label>
          </div>
        </div>
        <!--        //匹配中／上传中的样式-->
        <div class="batch-upload-step-third" v-if="matchStep==3"
             @drop.stop.prevent="()=>{}"
             @dragover.stop.prevent="()=>{}">
          <div class="step-third-circle">
            <img class="img-circle" src="@/assets/image/batch-upload-dialog/ic_circle.png">
            <img class="img-circle-center" src="@/assets/image/batch-upload-dialog/ic_circle_center.png">
            <span class="span-progress">{{ `${matchProgress}%` }}</span>
          </div>
          <div class="step-third-tip">
            <span class="span-text">文件夹共</span>
            <span class="span-info">{{ allFileCount }}个文件</span>
            <!--            <span class="span-text">，匹配成功</span>-->
            <!--            <span class="span-info">{{ successFileCount }}个文件</span>-->
            <!--            <span class="span-text">，匹配失败</span>-->
            <!--            <span class="span-err">{{ failFileCount }}个文件</span>-->
          </div>
          <div class="step-third-btn">
            <button class="btn-cancel" @click.stop="clickCancel">取消</button>
            <button class="btn-small" @click.stop="clickSmall">最小化</button>
          </div>
        </div>
        <div class="batch-upload-step-four" v-if="matchStep==4"
             @drop.stop.prevent="()=>{}"
             @dragover.stop.prevent="()=>{}">
          <div class="step-four-info">
            <div class="info-left">
              <div class="info-left-top">
                <img src="@/assets/image/batch-upload-dialog/ic_attend.png">
                <div class="info-left-tip">
                  <div>
                    <span class="span-text">共上传</span><span class="span-info">{{ allUploadCount }}个文件</span>
                    <!--                    <span class="span-text">，匹配成功</span><span class="span-info">{{ successFileCount }}个文件</span>-->
                  </div>
                  <div>
                    <!--                    <span class="span-text">匹配失败</span>-->
                    <!--                    <span class="span-err">{{ failFileCount }}个文件</span>-->
                  </div>
                </div>
              </div>
              <div class="info-left-btn">
                <button class="btn-retry" @click.stop="clickRetry">再次上传</button>
              </div>
            </div>
            <div class="info-line"></div>
            <div class="info-right">
              <span><span style="font-weight: bold;">数据包规范说明：</span><br/>
                1、请按照一个案件一个文件夹的方式整理文书，文件夹以被申请人名称命名；<br/>
                2、上传文书应为PDF、word格式，单个大小0KB以上，50M以下<br/>
              3、文件名称按照文书类型进行命名<br/>
              4、文件名称中请勿包含换行符、空格、tab#&\/:?"<>*|＼：？＃＊｜＆＂＜＞%+' 特殊字符。<br/>
              5、文件名称不超过45个字<br/>
              6、为避免出现程序性错误，系统将自动对您文件名中的隐藏字符进行删除，请您知悉！<br/>
              具体规范可参照样本范例
              </span>
              <img class="img-float-bg" src="@/assets/image/batch-upload-dialog/bg.png">
              <button class="btn-load-temp" @click="downLoadTemp">下载范本</button>
            </div>
          </div>
          <el-table class="step-four-table"
                    :data="tableList"
                    :max-height="tableHeight"
                    style="margin-top: 20px; width: 100%;">
            <el-table-column
              fixed="left"
              :show-overflow-tooltip="true"
              label="被申请人"
              prop="defName">
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              fixed="left"
              width="200px"
              label="案号"
              prop="caseNo">
            </el-table-column>
            <el-table-column
              fixed="left"
              align="left"
              width="600px"
              label="错误详情"
              prop="err">
              <template slot-scope="scope">
                <p class="tab-col-err" :title="scope.row.err">{{ scope.row.err }}</p>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <input class="el-upload__input" type="file" ref="batchUploadInput" @change="uploadChangeEvent"
             webkitdirectory>
    </div>
    <div v-show="isSmall" class="batch-upload-dialog-small-main">
      <div class="step-third-circle-small" @click="clickEnlarge">
        <img class="img-circle-small" src="@/assets/image/batch-upload-dialog/ic_circle.png">
        <img class="img-circle-center-small" src="@/assets/image/batch-upload-dialog/ic_circle_center.png">
        <span class="span-progress-small">{{ `${matchProgress}%` }}</span>
      </div>
    </div>
    <div :class="[isSmall?'match-dialog-small':'match-dialog']" v-show="dialogMatchVisible" :style="positionStyle">
      <div class="match-dialog-body">
        <img src="@/assets/image/batch-upload-dialog/ic_attend.png">
        <div class="match-dialog-tip">
          <span class="match-tip">{{ matchTip }}</span>
        </div>
      </div>
      <div class="match-dialog-footer">
        <button @click="clickSkip">跳过</button>
        <button @click="clickReplace">替换</button>
      </div>
    </div>
  </div>
</template>
<!--批量文书上传dialog-->
<script>
import MatchController from './match_controller';

/**
 * 前端excel导出
 */

export default {
  name: 'batch-upload-dialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    queryParams: {// 入口查询参数-业务
      type: Object,
      default: () => {
        return {};
      }
    },
    handlerFunc: {// 外部响应方法
      type: Function,
      default: (msg) => {
        return msg;
      }
    },
  },
  data() {
    return {
      isSmall: false,
      positionStyle: {},
      fileIsSeal: '',
      checked: false,
      matchTip: '',
      dialogMatchVisible: false,
      currentMatchCaseData: null,
      currentExceptData: null,
      matchProgress: 0, // 匹配上传进度
      progressTimer: null,
      // 文件匹配上传过程中的文件进度统计
      allFileCount: 0, // 总计文件
      successFileCount: 0, // 匹配成功文件
      failFileCount: 0, // 匹配失败文件
      allUploadCount: 0, // 上传文件总数量

      title: '文书批量上传',
      showLoading: false,
      matchStep: 4, // 匹配步骤 0初始化、1文件上传／案例下载弹框、2拖拽上传效果、3上传匹配中、4结果样式
      titleWidth: '635px',
      caseListPageInfo: {
        pn: 1,
        total: 0,
        totalPage: 0,
      },

      /**
       *  {
        "caseNo": "string",
        "defName": "string",
        "mediateId": "string"
      }
       */
      caseList: [], // 需要匹配的调解案件列表
      tableHeight: '400px',
      tableList: [// jsonData
        // {
        //   defName: '测试',
        //   caseNo: '测试2',
        //   err: '(调解告知书)文件内容超5m，(调解申请书)文件内容超5m，(司法确认书)名字错误(调解告知书)文件内容超5m，(调解申请书)文件内容超5m，(司法确认书)名字错误(调解告知书)文件内容超5m，(调解申请书)文件内容超5m，(司法确认书)名字错误(调解告知书)文件内容超5m，(调解申请书)文件内容超5m，(司法确认书)名字错误',
        // }
      ],
      // 导出excel
      jsonExcelFields: {
        '被申请人': 'defName',
        '案号': 'caseNo',
        '错误详情': 'err',
      },
    };
  },
  watch: {
    visible() {
      if (this.visible && this.queryParams && Object.keys(this.queryParams).length > 0) {
        // 展示批量上传入口弹窗界面
        this.init();
      } else {
        MatchController.clearAll();
      }
    },
  },
  methods: {
    init() {
      this.matchStep = 1;
      this.titleWidth = '635px';
      this.isSmall = false;
      document.body.style.overflow = 'hidden';
      this.queryInit();
      this.$nextTick(() => {
        this.fileIsSeal = '';
        console.log('document.body.clientHeight', this.tableHeight, this.$refs.refBatchUploadDialogDiv);
        this.tableHeight = `${this.$refs.refBatchUploadDialogDiv.clientHeight - 400}px`;
      });
    },
    // 初始化查询数据，需要查询到最后一页
    queryInit() {
      this.showLoading = true;
      this.caseListPageInfo = this.$options.data().caseListPageInfo;
      this.updatePageParams();
      this.getCaseList(() => {
        console.log('queryInit', this.caseList.length, this.caseListPageInfo);
        this.showLoading = false;
      }, () => {
        this.showLoading = false;
      });
    },

    updatePageParams() {
      if (this.caseListPageInfo.pn < this.caseListPageInfo.totalPage) {
        this.caseListPageInfo.pn++;
      }
      this.queryParams.pageNo = this.caseListPageInfo.pn;
      this.queryParams.pageSize = 10;
    },

    getCaseList(success, fail) {
      this.$api.getBatchUploadList(this.queryParams).then(res => {
        if (res && res.code == 200 && res.data) {
          this.caseListPageInfo.totalPage = res.data.totalPage;
          this.caseListPageInfo.total = res.data.total;
          if (res.data.record && res.data.record.length > 0) {
            res.data.record.forEach(item => {
              this.caseList.push({
                caseNo: item.caseNo,
                defName: item.defendantStr,
                mediateId: item.mediateId,
              });
            });
          }
          if (this.caseListPageInfo.pn < this.caseListPageInfo.totalPage) {
            this.updatePageParams();
            this.getCaseList(success, fail);
          } else if (success) {
            success();
          }
        } else if (fail) {
          fail();
        }
      }, err => {
        if (fail) {
          fail();
        }
      });
    },

    // 清理所有数据
    clearAll() {
      this.caseList = this.$options.data().caseList;
      this.caseListPageInfo = this.$options.data().caseListPageInfo;
      this.tableHeight = this.$options.data().tableHeight;
      this.tableList = this.$options.data().tableList;
      this.showLoading = false;
      this.matchStep = 0;
      this.matchProgress = 0;
      this.failFileCount = 0;
      this.successFileCount = 0;
      this.allFileCount = 0;
      this.allUploadCount = 0;
      this.fileIsSeal = '';
      clearInterval(this.progressTimer);
    },
    hideDialog() {
      if (this.dialogMatchVisible) {
        return;
      }

      if (this.matchStep == 4 || this.matchStep == 1) {
        this.clearAll();
        this.callHideFunc();
      } else {
        this.$confirm('此操作将取消批量上传, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.clearAll();
          this.callHideFunc();
        })
          .catch(() => {
          });
      }
    },

    callHideFunc() {
      if (this.handlerFunc) {
        this.handlerFunc('hide');
      }
    },

    handlerDrop(e) {
      // this.matchStep = 1
      if (this.fileIsSeal) {
        const item = e.dataTransfer.items[0].webkitGetAsEntry();
        console.log('handlerDrop', e.dataTransfer);
        MatchController.clearAll();
        this.matchFunc(item);
      } else {
        this.$message.warning('请先选择签字类型');
        this.matchStep = 1;
      }
    },

    handlerDragover(e) {
      console.log('handlerDragover', e);
      this.matchStep = 2;
      e.preventDefault();
      return false;
    },


    uploadChangeEvent(e) {
      console.log('uploadChangeEvent', e.target, e.target.webkitEntries, this.$refs.batchUploadInput);
      if (e.target.files && e.target.files.length > 0) {
        this.showLoading = false;
      } else {
        this.showLoading = false;
      }
    },

    clickSkip() {
      if (this.isFileMatch) {
        MatchController.matchFileExceptionReceipt('skip', this.checked, this.currentExceptData);
      } else {
        MatchController.matchExceptionReceipt('skip', this.checked, this.currentExceptData);
      }

      this.dialogMatchVisible = false;
    },

    clickReplace() {
      if (this.isFileMatch) {
        MatchController.matchFileExceptionReceipt('replace', this.checked, this.currentExceptData);
      } else {
        MatchController.matchExceptionReceipt('replace', this.checked, this.currentExceptData);
      }
      this.dialogMatchVisible = false;
    },

    showMatchDialog(isDialogOpen, matchTip, isFileMatch) {
      if (isDialogOpen) {
        this.checked = false;
        this.matchTip = matchTip;
        this.isFileMatch = isFileMatch;
      }
      const timer = setTimeout(() => {
        this.dialogMatchVisible = true;
        clearTimeout(timer);
      }, 50);
    },

    syncFileCount() {
      this.matchProgress = MatchController.progress;
      this.allFileCount = MatchController.allFileCount;
      this.allUploadCount = MatchController.allUploadCount;
      this.successFileCount = MatchController.successFileCount;
      this.failFileCount = MatchController.failFileCount;
    },

    /**
     *
     * @param item { FileSystemDirectoryEntry }
     */
    matchFunc(item) {
      if (item.isDirectory) {// 文件夹
        this.matchStep = 3;
        const dirReader = item.createReader();
        if (dirReader) {
          dirReader.readEntries(res => {
            if (res && res.length) {
              MatchController.isSeal = this.fileIsSeal == '1';
              MatchController.batchId = this.queryParams.batchId ? this.queryParams.batchId : '';
              MatchController.isKeep = false;
              MatchController.lastCmd = '';
              MatchController.drag_step_first(res, this.caseList, (throwInfo) => {
                // 需要弹窗处理异常
                console.log('drag_step_first-弹窗处理异常', throwInfo.tip, throwInfo);
                this.currentExceptData = throwInfo;
                if (MatchController.isKeep) {
                  this.checked = true;
                  this.matchTip = throwInfo.tip;
                  this.isFileMatch = false;
                  switch (MatchController.lastCmd) {
                    case 'skip':
                      this.clickSkip();
                      break;
                    case 'replace':
                      this.clickReplace();
                      break;
                  }
                } else {
                  this.showMatchDialog(true, throwInfo.tip, false);
                }
              }, (matchList) => {
                console.log('handlerDrop-complete', matchList);
                if (matchList.code == 200) {
                  // 执行第二步匹配
                  MatchController.isKeep = false;
                  MatchController.lastCmd = '';
                  MatchController.drag_step_second((exceptData) => {
                    console.log('drag_step_second抛出了匹配异常', exceptData);
                    // keep抛出来处理，内部逻辑太过于复杂
                    this.currentExceptData = exceptData;
                    if (MatchController.isKeep) {
                      this.checked = true;
                      this.matchTip = exceptData.tip;
                      this.isFileMatch = true;
                      switch (MatchController.lastCmd) {
                        case 'skip':
                          this.clickSkip();
                          break;
                        case 'replace':
                          this.clickReplace();
                          break;
                      }
                    } else {
                      this.showMatchDialog(true, exceptData.tip, true);
                    }
                  }, (res) => {
                    console.log('drag_step_second完成了匹配', res);
                    this.matchProgress = 100;
                    const timer = setTimeout(() => {
                      clearTimeout(timer);
                      this.clickEnlarge();
                      this.syncFileCount();
                      if (res && res.code == 200) {
                        // 匹配完成展示错误和统计结果
                        clearInterval(this.progressTimer);
                        console.log('MatchController.errorList', MatchController.errorList);
                        this.showResultView([], MatchController.errorList, MatchController.allFileCount);
                      } else {
                        // 出现匹配异常
                        const errMsg = res.msg ? res.msg : '匹配异常，请重试';
                        this.$message.error(errMsg);
                        clearInterval(this.progressTimer);
                        // 展示处理错误结果/文件规范检查
                        this.showResultView([], [], 0);
                      }
                    }, 1000);
                  }, false, null);
                } else {
                  this.$message.error(matchList.msg ? matchList.msg : '匹配异常，请重试');
                  clearInterval(this.progressTimer);
                  // 展示处理错误结果/文件规范检查
                  this.showResultView([], [], 0);
                }
              }, false);
              // 获取进度同步
              clearInterval(this.progressTimer);
              this.progressTimer = setInterval(() => {
                this.syncFileCount();
              }, 1000);
            }
          }, err => {
            console.log('readDirectory', dirReader, err);
          });
        }
      } else {// 文件
        this.$message.warning('请拖拽相应的文件夹上传');
        this.matchStep = 1;
      }
    },

    showResultView(successList, failList, allFileCount) {
      this.matchStep = 4;
      this.titleWidth = '1045px';

      String.prototype.endWith = function (str) {
        const reg = new RegExp(`${str}$`);
        return reg.test(this);
      };

      // 先处理错误展示表格
      if (failList && failList.length > 0) {
        this.tableList = [];
        failList.forEach(item => {
          if (item.defName.endWith('、')) {
            item.defName = item.defName.substring(0, item.defName.length - 1);
          }
          if (item.caseNo.endWith('、')) {
            item.caseNo = item.caseNo.substring(0, item.caseNo.length - 1);
          }
          if (item.err.endWith('、')) {
            item.err = item.err.substring(0, item.err.length - 1);
          }
          this.tableList.push({...item});
        });
      }
    },

    clickCancel() {
      this.hideDialog();
    },

    /**
     * 最小化处理，只是隐藏当前界面，展示进度球和异常弹窗
     */
    clickSmall() {
      if (this.dialogMatchVisible) {
        return;
      }
      this.isSmall = true;
      document.body.style.overflow = 'auto';
    },

    clickEnlarge() {
      if (this.dialogMatchVisible) {
        return;
      }
      this.isSmall = false;
      document.body.style.overflow = 'hidden';
    },

    clickRetry() {
      this.clearAll();
      if (MatchController) {
        MatchController.clearAll();
      }
      this.init();
    },

    downLoadTemp() {
      this.$api.downLoadBatchUploadTemp({type:'offline'}).then(res => {
        if (res && res.code == 200 && res.data) {
          this.$utils.downloadFile(res.data);
        }
      }, err => {

      });
    },

  },

};
</script>

<style lang="scss" rel="stylesheet/scss">
button {
    cursor: pointer;
}

.batch-upload-dialog {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.64);
}

.batch-upload-dialog-small {
    position: fixed;
    top: calc(50vh - 34px);
    right: 0;
    z-index: 99;
    display: flex;
    justify-content: center;
    align-items: center;
}

.batch-upload-dialog-small-main {
    width: 68px;
    height: 68px;
}

.step-third-circle-small {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    .img-circle-small {
        position: absolute;
        top: calc(50% + 40px);
        width: 63px;
        height: 63px;
        animation: circle-rotate 2s linear infinite;
    }

    .img-circle-center-small {
        position: absolute;
        top: calc(50% + 43.5px);
        width: 55px;
        height: 55px;
    }

    .span-progress-small {
        position: absolute;
        top: calc(50% + 63.5px);
        color: #fff;
        font-size: 14px;
        font-family: "MicrosoftYaHei-Bold";
    }
}

.batch-upload-dialog-main {
    display: flex;
    flex-direction: column;
    background: #f8f8f8;
}

.batch-upload-dialog-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-right: 24px;
    padding-left: 40px;
    height: 56px;
    border-bottom: 1px solid #e8e8e8;
}

.batch-upload-step-first {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 40px;
    background: #fff;

    .step-first-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 16px;
        width: 100%;
        height: 100%;
        border-radius: 2px;
        border: 1px solid #eee;

        > img {
            margin-top: 62px;
            width: 48px;
            height: 53px;
        }

        > span {
            margin-top: 5px;
            color: #999;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            line-height: 14px;
        }

        .btn-load-temp {
            margin-top: 24px;
            margin-bottom: 62px;
            width: 216px;
            height: 36px;
            color: #333;
            font-size: 16px;
            font-family: MicrosoftYaHei;
            line-height: 16px;
            border-radius: 2px;
            border: 1px solid #eee;
            background: transparent;
        }
    }
}

.step-first-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    > span {
        color: #999;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        line-height: 14px;
    }
}

.batch-upload-step-second {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 40px;
    width: 100%;
    background: #fff;

    .step-second-content {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 16px;
        width: 100%;
        height: 256px;
        color: #999;
        font-size: 24px;
        font-family: MicrosoftYaHei;
        line-height: 24px;
        background: rgba(39, 78, 164, 0.12);
    }
}

.batch-upload-step-third {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 307px;
    border-radius: 4px;
    border-radius: 4px;
    background: url("../../../../../static/images/bg-circle.png");
    background-size: cover;
}

.step-third-circle {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;

    .img-circle {
        position: absolute;
        top: calc(50% + 80px);
        width: 126px;
        height: 126px;
        animation: circle-rotate 2s linear infinite;
    }

    .img-circle-center {
        position: absolute;
        top: calc(50% + 87px);
        width: 110px;
        height: 110px;
    }

    .span-progress {
        position: absolute;
        top: calc(50% + 127px);
        color: #fff;
        font-size: 28px;
        font-family: "MicrosoftYaHei-Bold";
    }
}

.step-third-tip {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 200px;
}

.step-third-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 32px;
    margin-bottom: 32px;
    width: 100%;

    .btn-cancel {
        width: 128px;
        height: 36px;
        color: #333;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        line-height: 16px;
        border-radius: 2px;
        border: 1px solid #ddd;
        background: #fff;
    }

    .btn-small {
        margin-left: 24px;
        width: 128px;
        height: 36px;
        color: #fff;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        line-height: 16px;
        border-radius: 2px;
        border: 0;
        background: #274ea4;
    }
}

.batch-upload-step-four {
    display: flex;
    flex-direction: column;
    padding: 40px;
    width: 100%;
    background: #fff;
}

.step-four-info {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 22px 17px;
    width: 100%;
    border-radius: 2px;
    border: 1px solid #eee;
}

.info-left-top {
    display: flex;
    flex-direction: row;
    align-items: center;

    > img {
        margin-right: 12px;
        width: 48px;
        height: 48px;
    }
}

.info-left-btn {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 12px;
    padding-left: 59px;

    .btn-retry {
        width: 147px;
        height: 36px;
        color: #0d0d0d;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        line-height: 16px;
        border-radius: 2px;
        border: 1px solid #eee;
        background: #fff;
    }

    .btn-download {
        margin-left: 24px;
        width: 147px;
        height: 36px;
        color: #fff;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        line-height: 16px;
        border-radius: 2px;
        border: 0;
        background: #274ea4;
    }
}

.info-line {
    margin: 0 16px;
    width: 1px;
    border: 0;
    background: #eee;
}

.info-left {
    flex: 1;
}

.info-right {
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;

    .img-float-bg {
        position: absolute;
        right: 0;
        bottom: -22px;
        z-index: 2;
        width: 258px;
        height: 258px;
    }

    > span {
        z-index: 3;
        color: #333;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 24px;
    }

    .btn-load-temp {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 12px;
        width: 128px;
        height: 36px;
        color: #333;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        line-height: 16px;
        text-decoration: none;
        border-radius: 2px;
        border: 1px solid #eee;
        background: #fff;
        cursor: pointer;
    }
}

.span-text {
    color: #333;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    line-height: 24px;
}

.span-info {
    color: #274ea4;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    line-height: 24px;
}

.span-err {
    color: #c42f2c;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    line-height: 24px;
}

.step-four-table {

}

.tab-col-err {
    color: #c42f2c;
}

.match-dialog {
    position: absolute;
    top: 60px;
    display: flex;
    flex-direction: column;
    width: 588px;
    box-shadow: 0 5px 5px #999;
}

.match-dialog-small {
    position: absolute;
    top: 50px;
    right: 75px;
    display: flex;
    flex-direction: column;
    width: 588px;
    border-radius: 4px;
    border: 1px solid #eaeaea;
    box-shadow: 0 4px 12px 8px rgba(0, 0, 0, 0.12);
}

.match-dialog-body {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 20px 36px;
    background: #fff;

    .match-tip {
        color: #666;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        line-height: 21px;
    }

    > img {
        margin-right: 12px;
        width: 52px;
        height: 52px;
    }

    .match-dialog-tip {
        display: flex;
        flex-direction: column;
        color: #333;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        line-height: 14px;

        .match-dialog-check {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 16px;

            .tip {
                margin-left: 4px;
            }

            .mark {
                color: #999;
            }
        }
    }
}

.match-dialog-footer {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding-right: 7px;
    width: 100%;
    height: 68px;
    border-radius: 0 0 4px 4px;
    background: #f8f8f8;

    > button {
        margin-right: 28px;
        padding-top: 10px;
        padding-bottom: 10px;
        width: 118px;
        height: 36px;
        color: #333;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        line-height: 16px;
        text-align: center;
        border-radius: 4px;
        border: 1px solid #ddd;
        background: #fff;
        cursor: pointer;
    }
}

@keyframes circle-rotate {
    0% {
        -webkit-transform: rotate(0deg);
    }

    25% {
        -webkit-transform: rotate(90deg);
    }

    50% {
        -webkit-transform: rotate(180deg);
    }

    75% {
        -webkit-transform: rotate(270deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
    }
}

@-webkit-keyframes circle-rotate {
    0% {
        -webkit-transform: rotate(0deg);
    }

    25% {
        -webkit-transform: rotate(90deg);
    }

    50% {
        -webkit-transform: rotate(180deg);
    }

    75% {
        -webkit-transform: rotate(270deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
    }
}

</style>
